import { useState } from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sidebar } from 'primereact/sidebar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ReporteHistoricoEvidencias } from '../../pages/reportes/ReporteHistoricoEvidencias';
import { storage } from '../../helpers/storage';

const MenuUniformesPublico = ({ link }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const perfil = storage.get('perfilid');
    const ciclo = storage.get('ciclo');
    const [loadingDescarga, setLoadingDescarga] = useState(false);

    const handleDescargar = async () => {
        setLoadingDescarga(true);
        const reporte = await ReporteHistoricoEvidencias();
        let excel = reporte;

        let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
        let download = document.createElement('a');
        download.href = temp;
        download.download = `Histórico_Evidencias.xlsx`;
        document.body.appendChild(download);
        download.click();
        document.body.removeChild(download);
        setLoadingDescarga(false);
    }


    const nestedMenuitems =
        [21].includes(perfil) ?
            [
                {
                    label: 'Dashboard',
                    icon: 'pi pi-fw pi-chart-line',
                    style: {
                        textShadow: location.pathname === '/dashboard' && '0 0 red',
                        color: location.pathname === '/dashboard' && '#9b2f3e !important',
                        fontWeight: location.pathname === '/dashboard' && '500',
                        textDecorationColor: location.pathname === '/dashboard' && '#9b2f3e',

                    },
                    command: e => {
                        navigate('/dashboard');
                    }
                },
                {
                    label: 'Filtro',
                    icon: 'pi pi-search',
                    style: {
                        textShadow: location.pathname === '/filtro/na' && '0 0 red',
                        color: location.pathname === '/filtro/na' && '#9b2f3e !important',
                        fontWeight: location.pathname === '/filtro/na' && '500',
                        textDecorationColor: location.pathname === '/filtro/na' && '#9b2f3e'

                    },
                    command: e => {
                        navigate('/filtro/na');
                    }
                },
                {
                    label: 'Reportes',
                    icon: 'pi pi-fw pi-cog',
                    style: {
                        textShadow: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '0 0 red',
                        color: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '#9b2f3e !important',
                        fontWeight: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '500',
                        textDecorationColor: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '#9b2f3e'
                    },
                    items: [{
                        label: 'General',
                        icon: 'pi pi-fw pi-file-pdf',
                        command: e => {
                            navigate('/reporte-general');
                        }
                    },
                    {
                        label: 'Bitácora',
                        icon: 'pi pi-fw pi-file-pdf',
                        command: e => {
                            navigate('/reporte/corte-administrador');
                        }
                    },
                        /* {
                            label: 'Evidencias',
                            icon: 'pi pi-fw pi-file-pdf',
                            command: e => {
                                navigate('/reporte/evidencias');
                            }
                        } */
                    ]
                },
                {

                    label: 'Gestión evidencias',
                    icon: 'pi pi-image',
                    style: {
                        textShadow: location.pathname === '/evidencias' && '0 0 red',
                        color: location.pathname === '/evidencias' && '#9b2f3e !important',
                        fontWeight: location.pathname === '/evidencias' && '500',
                        textDecorationColor: location.pathname === '/evidencias' && '#9b2f3e'

                    },
                    command: e => {
                        navigate('/evidencias');
                    }

                }

            ]
            :
            ![19].includes(perfil) ?
                ![20].includes(perfil) ?
                    [
                        {
                            label: 'Dashboard',
                            icon: 'pi pi-fw pi-chart-line',
                            style: {
                                textShadow: location.pathname === '/dashboard' && '0 0 red',
                                color: location.pathname === '/dashboard' && '#9b2f3e !important',
                                fontWeight: location.pathname === '/dashboard' && '500',
                                textDecorationColor: location.pathname === '/dashboard' && '#9b2f3e'
                            },
                            command: e => {
                                navigate('/dashboard');
                            }
                        },
                        {
                            label: 'Filtro',
                            icon: 'pi pi-search',
                            style: {
                                textShadow: location.pathname === '/filtro/na' && '0 0 red',
                                color: location.pathname === '/filtro/na' && '#9b2f3e !important',
                                fontWeight: location.pathname === '/filtro/na' && '500',
                                textDecorationColor: location.pathname === '/filtro/na' && '#9b2f3e'

                            },
                            command: e => {
                                navigate('/filtro/na');
                            }
                        }, {
                            label: 'Reportes',
                            icon: 'pi pi-fw pi-cog',
                            style: {
                                textShadow: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '0 0 red',
                                color: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '#9b2f3e !important',
                                fontWeight: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '500',
                                textDecorationColor: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '#9b2f3e'
                            },
                            items: [{
                                label: 'General',
                                icon: 'pi pi-fw pi-file-pdf',
                                command: e => {
                                    navigate('/reporte-general');
                                }
                            },
                            {
                                label: 'Bitácora',
                                icon: 'pi pi-fw pi-file-pdf',
                                command: e => {
                                    navigate('/reporte/corte-administrador');
                                }
                            },
                                /*  {
                                     label: 'Evidencias',
                                     icon: 'pi pi-fw pi-file-pdf',
                                     command: e => {
                                         navigate('/reporte/evidencias');
                                     }
                                 } */
                            ]
                        },
                        {
                            label: 'Vales',
                            icon: 'pi pi-ticket',
                            style: {
                                textShadow: location.pathname === '/imprenta-vales' && '0 0 red',
                                color: location.pathname === '/imprenta-vales' && '#9b2f3e !important',
                                fontWeight: location.pathname === '/imprenta-vales' && '500',
                                textDecorationColor: location.pathname === '/imprenta-vales' && '#9b2f3e'
                            },
                            command: e => {
                                navigate('/imprenta-vales')
                            }
                        },
                        {

                            label: 'Gestión evidencias',
                            icon: 'pi pi-image',
                            style: {
                                textShadow: location.pathname === '/evidencias' && '0 0 red',
                                color: location.pathname === '/evidencias' && '#9b2f3e !important',
                                fontWeight: location.pathname === '/evidencias' && '500',
                                textDecorationColor: location.pathname === '/evidencias' && '#9b2f3e'

                            },
                            command: e => {
                                navigate('/evidencias');
                            }

                        }
                    ]
                    :
                    [
                        {
                            label: 'Dashboard',
                            icon: 'pi pi-fw pi-chart-line',
                            style: {
                                textShadow: location.pathname === '/dashboard' && '0 0 red',
                                color: location.pathname === '/dashboard' && '#9b2f3e !important',
                                fontWeight: location.pathname === '/dashboard' && '500',
                                textDecorationColor: location.pathname === '/dashboard' && '#9b2f3e'
                            },
                            command: e => {
                                navigate('/dashboard');
                            }
                        },
                        {
                            label: 'Filtro',
                            icon: 'pi pi-search',
                            style: {
                                textShadow: location.pathname === '/filtro/na' && '0 0 red',
                                color: location.pathname === '/filtro/na' && '#9b2f3e !important',
                                fontWeight: location.pathname === '/filtro/na' && '500',
                                textDecorationColor: location.pathname === '/filtro/na' && '#9b2f3e'

                            },
                            command: e => {
                                navigate('/filtro/na');
                            }
                        },
                        {
                            label: 'Reportes',
                            icon: 'pi pi-fw pi-cog',
                            style: {
                                textShadow: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '0 0 red',
                                color: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '#9b2f3e !important',
                                fontWeight: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '500',
                                textDecorationColor: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '#9b2f3e'
                            },
                            items: [{
                                label: 'General',
                                icon: 'pi pi-fw pi-file-pdf',
                                command: e => {
                                    navigate('/reporte-general');
                                }
                            },
                                /* {
                                    label: 'Bitácora',
                                    icon: 'pi pi-fw pi-file-pdf',
                                    command: e => {
                                        navigate('/reporte/corte-administrador');
                                    }
                                }, */
                                /* {
                                    label: 'Evidencias',
                                    icon: 'pi pi-fw pi-file-pdf',
                                    command: e => {
                                        navigate('/reporte/evidencias');
                                    }
                                } */
                            ]
                        },
                        {
                            label: 'Vales',
                            icon: 'pi pi-ticket',
                            style: {
                                textShadow: location.pathname === '/imprenta-vales' && '0 0 red',
                                color: location.pathname === '/imprenta-vales' && '#9b2f3e !important',
                                fontWeight: location.pathname === '/imprenta-vales' && '500',
                                textDecorationColor: location.pathname === '/imprenta-vales' && '#9b2f3e'
                            },
                            command: e => {
                                navigate('/imprenta-vales')
                            }
                        },
                        {
                            label: 'Gestión maquilas',
                            icon: 'pi pi-book',
                            style: {
                                textShadow: location.pathname === '/maquila' && '0 0 red',
                                color: location.pathname === '/maquila' && '#9b2f3e !important',
                                fontWeight: location.pathname === '/maquila' && '500',
                                //textDecoration: location.pathname === '/archivos' && 'underline',
                                textDecorationColor: location.pathname === '/maquila' && '#9b2f3e'

                            },
                            command: e => {
                                navigate('/maquila');
                            }
                        },
                        {
                            label: 'Gestión evidencias',
                            icon: 'pi pi-image',
                            style: {
                                textShadow: location.pathname === '/evidencias' && '0 0 red',
                                color: location.pathname === '/evidencias' && '#9b2f3e !important',
                                fontWeight: location.pathname === '/evidencias' && '500',
                                textDecorationColor: location.pathname === '/evidencias' && '#9b2f3e'

                            },
                            command: e => {
                                navigate('/evidencias');
                            }

                        }
                    ]
                :

                [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-chart-line',
                        style: {
                            textShadow: location.pathname === '/dashboard' && '0 0 red',
                            color: location.pathname === '/dashboard' && '#9b2f3e !important',
                            fontWeight: location.pathname === '/dashboard' && '500',
                            textDecorationColor: location.pathname === '/dashboard' && '#9b2f3e',

                        },
                        command: e => {
                            navigate('/dashboard');
                        }
                    },
                    {
                        label: 'Filtro',
                        icon: 'pi pi-search',
                        style: {
                            textShadow: location.pathname === '/filtro/na' && '0 0 red',
                            color: location.pathname === '/filtro/na' && '#9b2f3e !important',
                            fontWeight: location.pathname === '/filtro/na' && '500',
                            textDecorationColor: location.pathname === '/filtro/na' && '#9b2f3e'

                        },
                        command: e => {
                            navigate('/filtro/na');
                        }
                    },
                    {
                        label: 'Vales',
                        icon: 'pi pi-ticket',
                        style: {
                            textShadow: location.pathname === '/imprenta-vales' && '0 0 red',
                            color: location.pathname === '/imprenta-vales' && '#9b2f3e !important',
                            fontWeight: location.pathname === '/imprenta-vales' && '500',
                            textDecorationColor: location.pathname === '/imprenta-vales' && '#9b2f3e',
                        },
                        command: e => {
                            navigate('/imprenta-vales')
                        }
                    },


                    {
                        label: 'Nóminas',
                        icon: 'pi pi-file',
                        style: {
                            textShadow: location.pathname === '/imprenta-nominas' && '0 0 red',
                            color: location.pathname === '/imprenta-nominas' && '#9b2f3e !important',
                            fontWeight: location.pathname === '/imprenta-nominas' && '500',
                            textDecorationColor: location.pathname === '/imprenta-nominas' && '#9b2f3e',
                            display: ciclo && ciclo.IdCicloEscolar < 6 ? 'block' : 'none',

                        },
                        command: e => {
                            navigate('/imprenta-nominas')
                        }
                    },

                    {
                        label: 'Reportes',
                        icon: 'pi pi-fw pi-cog',
                        style: {
                            textShadow: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '0 0 red',
                            color: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '#9b2f3e !important',
                            fontWeight: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '500',
                            textDecorationColor: (location.pathname === '/reporte-general' || location.pathname === '/reporte/corte-administrador') && '#9b2f3e'
                        },
                        items: [{
                            label: 'General',
                            icon: 'pi pi-fw pi-file-pdf',
                            command: e => {
                                navigate('/reporte-general');
                            }
                        },
                        /* {
                            label: 'Bitácora',
                            icon: 'pi pi-fw pi-file-pdf',
                            command: e => {
                                navigate('/reporte/corte-administrador');
                            }
                        }, */
                        {
                            label: 'Maquila',
                            icon: 'pi pi-fw pi-file-pdf',
                            command: e => {
                                navigate('/reporte/maquila');
                            }
                        }, {
                            label: 'Histórico evidencias',
                            icon: 'pi pi-fw pi-file-pdf',
                            command: e => {
                                handleDescargar();
                            }
                        }
                            /* {
                                label: 'Evidencias',
                                icon: 'pi pi-fw pi-file-pdf',
                                command: e => {
                                    navigate('/reporte/evidencias');
                                }
                            } */
                        ]
                    },
                    {
                        label: 'Configuración',
                        icon: 'pi pi-users',
                        style: {
                            textShadow: location.pathname === '/configuracion/usuarios' || location.pathname === '/configuracion/ciclo' && '0 0 red',
                            color: location.pathname === '/configuracion/usuarios' || location.pathname === '/configuracion/ciclo' && '#9b2f3e !important',
                            fontWeight: location.pathname === '/configuracion/usuarios' || location.pathname === '/configuracion/ciclo' && '500',
                            textDecorationColor: location.pathname === '/configuracion/usuarios' || location.pathname === '/configuracion/ciclo' && '#9b2f3e',

                        },
                        items: [
                            {
                                label: 'Usuarios',
                                icon: 'pi pi-fw pi-user-plus',
                                command: e => {
                                    navigate('/configuracion/usuarios');
                                }
                            },
                            {
                                label: 'Ciclos',
                                icon: 'pi pi-fw pi-sync',
                                command: e => {
                                    navigate('/configuracion/ciclo');
                                }
                            }
                        ]
                    },
                    {
                        label: 'Gestión maquilas',
                        icon: 'pi pi-book',
                        style: {
                            textShadow: location.pathname === '/maquila' && '0 0 red',
                            color: location.pathname === '/maquila' && '#9b2f3e !important',
                            fontWeight: location.pathname === '/maquila' && '500',
                            //textDecoration: location.pathname === '/archivos' && 'underline',
                            textDecorationColor: location.pathname === '/maquila' && '#9b2f3e',

                        },
                        command: e => {
                            navigate('/maquila');
                        }
                    },
                    {
                        label: 'Gestión evidencias',
                        icon: 'pi pi-image',
                        style: {
                            textShadow: location.pathname === '/evidencias' && '0 0 red',
                            color: location.pathname === '/evidencias' && '#9b2f3e !important',
                            fontWeight: location.pathname === '/evidencias' && '500',
                            textDecorationColor: location.pathname === '/evidencias' && '#9b2f3e'

                        },
                        command: e => {
                            navigate('/evidencias');
                        }

                    }
                ];



    return (
        <div className="col-12" style={{ marginBottom: "15px" }}>
            <Sidebar
                fullScreen
                visible={loadingDescarga}
                style={{ background: 'lightgray', opacity: '60%' }}
                showCloseIcon={false}>
                <div className="text-center" style={{ marginTop: '200px' }}>
                    <ProgressSpinner />
                    <div className="col-12" style={{ color: 'black', fontSize: '14px' }}><strong>{`Descargando Evidencias...`}</strong></div>
                </div>
            </Sidebar>
            <Menubar model={nestedMenuitems} className="surface-card"></Menubar>
        </div>
    );
}

export default MenuUniformesPublico;